import { render, staticRenderFns } from "./index.modal.vue?vue&type=template&id=4d839842&scoped=true&"
import script from "./index.modal.vue?vue&type=script&lang=js&"
export * from "./index.modal.vue?vue&type=script&lang=js&"
import style0 from "./index.modal.vue?vue&type=style&index=0&id=4d839842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d839842",
  null
  
)

export default component.exports